import { FaCheckCircle } from "react-icons/fa";
import { FaPhone } from "react-icons/fa6";
import CustomButton from "shared/components/button/CustomButton";
import BodyPanel from "shared/components/panel/BodyPanel";
import HeaderPanel from "shared/components/panel/HeaderPanel";
import { Panel } from "shared/components/panel/Panel";
import ModalTermosDeUsoGroupPay from "./ModalTermosDeUsoGroupPay";
import { useContext, useState } from "react";
import ModalVisualizarConcessionariasDisponiveisGroupPay from "./ModalVisualizarConcessionariasDisponiveisGroupPay";
import { UserContext } from "context/UserContext";
import { usePostCadastrarClienteGroupPay } from "hooks/groupPay/usePostCadastrarClienteGroupPay";

const TelaPropostaComercialGroupPay: React.FC = () => {
  const [showModalTermosDeUso, setShowModalTermosDeUso] = useState<boolean>(false);
  const [showModalConcessionariasDisponiveis, setShowModalConcessionariasDisponiveis] = useState<boolean>(false);
  const { usuarioLogado } = useContext(UserContext);
  const { mutateAsync: postCadastrarClienteGroupPay } = usePostCadastrarClienteGroupPay(usuarioLogado.codigoSuporte);

  const renderTituloPropostaComercial = () => {
    return <h2 className="fw-bold">Tenha tudo em um só lugar</h2>;
  };

  const renderListaFuncionalidadesGroupPay = () => {
    return (
      <div className="lista-funcionalidades-group-pay">
        {renderPrimeiraColunaFuncionalidades()}
        {renderSegundaColunaFuncionalidades()}
      </div>
    );
  };

  const renderPrimeiraColunaFuncionalidades = () => {
    return (
      <div className="coluna-funcionalidades-group-pay">
        <div>
          <FaCheckCircle color="#63b0df" /> Disponível para todos os seus condomínios
        </div>
        <div>
          <FaCheckCircle color="#63b0df" /> Coleta de Notas Fiscais (NF e NFe)
        </div>
        <div>
          <FaCheckCircle color="#63b0df" /> Anexo automático de documentos
        </div>
      </div>
    );
  };

  const renderSegundaColunaFuncionalidades = () => {
    return (
      <div className="coluna-funcionalidades-group-pay">
        {/* <div>
          <FaCheckCircle color="#63b0df" /> Integração com anexos de e-mail
        </div>
        <div>
          <FaCheckCircle color="#63b0df" /> Integração com concessionárias de água e energia
          <span className="link-span-group-pay" onClick={() => setShowModalConcessionariasDisponiveis(true)}>
            Ver mais
          </span>
        </div> */}
        {/* <div>
          <FaCheckCircle color="#63b0df" /> Coleta de arquivos de DDA (Débito Direto Autorizado)
        </div> */}
      </div>
    );
  };

  const renderBodyPropostaComercial = () => {
    return (
      <div className="body-proposta-comercial">
        {renderContratarGroupPay()}
        {renderBotaoSolicitarContato()}
        {renderDuvidas()}
      </div>
    );
  };

  const renderContratarGroupPay = () => {
    return <h2 className="contratar-group-pay">Contratar Group Pay</h2>;
  };

  const renderBotaoSolicitarContato = () => {
    return (
      <div className="solicitar-contato-group-pay-button">
        <CustomButton
          id="solicitar-contato-group-pay-button"
          label="Solicitar contato de um consultor"
          leftIcon={FaPhone}
          bigSize
          onClick={() => {
            cadastrarClienteGroupPay();
          }}
        />
      </div>
    );
  };

  const cadastrarClienteGroupPay = () => {
    postCadastrarClienteGroupPay(usuarioLogado.codigoSuporte).catch((e) => console.log(e));
  };

  const renderDuvidas = () => {
    return (
      <div className="mt-2 mb-3">
        Dúvidas sobre o Group Pay?
        <span className="link-span-group-pay" onClick={() => setShowModalTermosDeUso(true)}>
          termos de uso
        </span>
      </div>
    );
  };

  return (
    <Panel headerPanel={<HeaderPanel title="Group Pay" ocultarCondominio />}>
      <BodyPanel>
        {renderTituloPropostaComercial()}
        {renderListaFuncionalidadesGroupPay()}
        {renderBodyPropostaComercial()}
      </BodyPanel>

      <ModalTermosDeUsoGroupPay onCloseModal={() => setShowModalTermosDeUso(false)} showModal={showModalTermosDeUso} />
      <ModalVisualizarConcessionariasDisponiveisGroupPay
        showModal={showModalConcessionariasDisponiveis}
        onCloseModal={() => setShowModalConcessionariasDisponiveis(false)}
      />
    </Panel>
  );
};

export default TelaPropostaComercialGroupPay;
